<div class="flex-row align-between-center" >
    <div>
        {{message}}
    </div>
    <div>
        <a (click)="onDetails()" class="ml-12">Detalhes</a>
    </div>
</div>